import React, { Component, PropTypes } from 'react'
import { Link } from 'react-router'

import './ModifyService.scss'
import ModifyServiceNavBar from './components/ModifyServiceNavBar'
import AliadaProfileCard from 'components/AliadaProfileCard'
import ModifyServiceMenuItem from 'components/ModifyServiceMenuItem'
import { buildAddressString } from 'utils/addresses'
import * as paths from 'utils/paths'

class ModifyService extends Component {
  componentDidMount () {
    const { serviceId } = this.props

    this.fetchService(serviceId)
  }

  fetchService (id) {
    const { fetchService } = this.props
    fetchService(id)
  }

  isLoading () {
    const { fetchingService, service } = this.props
    return fetchingService || !service
  }

  render () {
    const {
      serviceId,
      service,
      aliada,
      params: {
        userId
      }
    } = this.props
    const loading = this.isLoading()

    return (
      <div className='ModifyService navbar-screen'>
        <ModifyServiceNavBar />
        {!loading &&
          <div className='ModifyService-content navbar-screen-content'>
            <div className='ModifyService-contentCard'>
              <div className='ModifyService-cardTitle'>
                Modificar servicio
              </div>
              <div className='ModifyService-serviceInfo'>
                <AliadaProfileCard
                  aliada={{
                    ...aliada,
                    serviceCost: service.cost
                  }}
                  estimatedServiceHours={service.estimatedHours}
                  />

                <p className='ModifyService-address'>
                  {buildAddressString(service.address)}
                </p>
              </div>
              <div className='ModifyService-menu'>
                <ModifyServiceMenuItem
                  icon='calendar'
                  to={paths.rescheduleService(userId, serviceId)}
                  label='Modificar fecha y hora'
                  />

                <ModifyServiceMenuItem
                  icon='user'
                  to={paths.serviceChangeAliadaSearch(userId, serviceId)}
                  label='Cambiar de Aliada'
                  />
              </div>

              <div className='ModifyService-buttons'>
                <Link
                  className='ModifyService-cancelButton btn btn-default btn-lg btn-block'
                  to={paths.userCancelService(userId, serviceId)}
                  >
                  Cancelar servicio
                </Link>
              </div>
            </div>
          </div>
        }
      </div>
    )
  }
}

ModifyService.displayName = 'ModifyService'
ModifyService.propTypes = {
  serviceId: PropTypes.number.isRequired,
  service: PropTypes.object,
  aliada: PropTypes.object,
  fetchingService: PropTypes.bool.isRequired,
  fetchService: PropTypes.func.isRequired,
  params: PropTypes.shape({
    userId: PropTypes.string.isRequired
  }).isRequired

}
ModifyService.defaultProps = {}

export default ModifyService



// WEBPACK FOOTER //
// ./src/screens/App/screens/Services/screens/ModifyService/ModifyService.js